"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../utils");

require("./TrafficGridContainer.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var TrafficGridContainer = /*#__PURE__*/function (_Component) {
  _inherits(TrafficGridContainer, _Component);

  var _super = _createSuper(TrafficGridContainer);

  function TrafficGridContainer(props) {
    var _this;

    _classCallCheck(this, TrafficGridContainer);

    _this = _super.call(this, props);
    var viewMode = _this.props.viewMode;
    _this.state = {
      selectedViewMode: viewMode,
      selectedTimeView: '6',
      timelineItems: [],
      trafficItems: undefined
    };
    return _this;
  }

  _createClass(TrafficGridContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkTimelineView();
      this.limitedTruckItems();
    }
    /**
     * @param  {string} type tipo de vista del timeline
     * @description cambia el tipo de vista del timeline
     */

  }, {
    key: "onChangeTimelineView",
    value: function onChangeTimelineView(type) {
      this.setState({
        selectedTimeView: type
      });
      this.checkTimelineView(type);
    }
    /**
     * @param {string} viewMode tipo de vista del conductor
     * @description cambia el modo vista de la pantalla
     */

  }, {
    key: "onChangeViewMode",
    value: function onChangeViewMode(viewMode) {
      this.setState({
        selectedViewMode: viewMode
      });
    }
    /**
     * @param {string} type determina el tipo de estilo del botón dependiendo de su posición
     * @param {boolean} isActive determina si el botón está activado
     * @description genera los estilos de los botones que cambian el tipo de vista
     */
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: "stylishShowViewButton",
    value: function stylishShowViewButton(type, isActive) {
      var classNames = 'showview-button';
      if (type === 'LEFT') classNames += ' showview-button--left';
      if (type === 'RIGHT') classNames += ' showview-button--right';
      if (isActive) classNames += ' showview-button--active';
      return classNames;
    }
    /**
     * @description agrega al contenedor principal una clase desde los props
     */

  }, {
    key: "checkCustomClass",
    value: function checkCustomClass() {
      var customClass = '';
      var className = this.props.className;
      if (className) customClass += " ".concat(className);
      return "traffic-grid-container".concat(customClass);
    }
    /**
     * @param {string} type tipo de vista del timeline
     * @description determina el tipo de vista y genera los encabezados del timeline
     */
    // eslint-disable-next-line react/destructuring-assignment

  }, {
    key: "checkTimelineView",
    value: function checkTimelineView() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.selectedTimeView;

      switch (type) {
        case '6':
          this.generateTimelineHeaders('hour', 'HH:00');
          break;

        case '12':
          this.generateTimelineHeaders('hour', 'HH:00', 2);
          break;

        case '24':
          this.generateTimelineHeaders('hour', 'HH:00', 4);
          break;

        case '144':
          this.generateTimelineHeaders('day', 'DD');
          break;

        default:
          this.generateTimelineHeaders('hour', 'HH:00');
      }
    }
    /**
     * @param {string} unit el tipo de unidad (hrs o dias)
     * @param {string} format formato del encabezado
     * @param {number} multiply multiplo que aumenta o disminuye el rango de las lineas en el timeline
     * @description genera todos los encabezados de las lineas del timeline
     */

  }, {
    key: "generateTimelineHeaders",
    value: function generateTimelineHeaders(unit, format) {
      var _this2 = this;

      var multiply = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      this.setState({
        timelineItems: []
      });

      var _loop = function _loop(i) {
        var hour = (0, _utils.calculateTime)(i, multiply, unit);

        _this2.setState(function (prev) {
          return {
            timelineItems: [].concat(_toConsumableArray(prev.timelineItems), [{
              time: hour.format(format),
              unit: unit,
              multiply: multiply
            }])
          };
        });
      };

      for (var i = -3; i < 3; i++) {
        _loop(i);
      }
    }
    /**
     * @description determina cuantos traffictItems se muestran en la vista
     */

  }, {
    key: "limitedTruckItems",
    value: function limitedTruckItems() {
      var _this$props = this.props,
          trafficItems = _this$props.trafficItems,
          maxViewItems = _this$props.maxViewItems;
      if (!!trafficItems === false) return;
      var limitedItems = trafficItems.slice(0, maxViewItems);
      this.setState({
        trafficItems: limitedItems
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          timelineItems = _this$state.timelineItems,
          trafficItems = _this$state.trafficItems,
          selectedViewMode = _this$state.selectedViewMode;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: this.checkCustomClass()
      }, /*#__PURE__*/_react["default"].createElement("section", {
        className: "options"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "showview"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: this.stylishShowViewButton('LEFT', selectedViewMode === 'TRIP'),
        onClick: function onClick() {
          return _this3.onChangeViewMode('TRIP');
        }
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Viaje")), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: this.stylishShowViewButton('RIGHT', selectedViewMode === 'TRUCK'),
        onClick: function onClick() {
          return _this3.onChangeViewMode('TRUCK');
        }
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Cami\xF3n")))), /*#__PURE__*/_react["default"].createElement("section", {
        className: "timeline"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "selected-time-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "selected-time"
      }, /*#__PURE__*/_react["default"].createElement("select", {
        onChange: function onChange(event) {
          return _this3.onChangeTimelineView(event.target.value);
        }
      }, /*#__PURE__*/_react["default"].createElement("option", {
        value: "6"
      }, "6 HORAS"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "12"
      }, "12 HORAS"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "24"
      }, "24 HORAS"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "144"
      }, "6 D\xCDAS")))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "timeline-history"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "timeline-container"
      }, timelineItems.map(function (item, i) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "timeline-barcode ".concat(i === 5 && 'timeline-barcode--left'),
          key: item
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "timeline-barcode__title timeline-barcode__title--left"
        }, /*#__PURE__*/_react["default"].createElement("span", null, item.time)), /*#__PURE__*/_react["default"].createElement("div", {
          className: "timeline-barcode__line"
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "timeline-barcode__line"
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "timeline-barcode__line"
        }), i === 5 && /*#__PURE__*/_react["default"].createElement("div", {
          className: "timeline-barcode__title timeline-barcode__title--right"
        }, /*#__PURE__*/_react["default"].createElement("span", null, (0, _utils.calculateTime)(3, item.multiply, item.unit).format(item.unit === 'hour' ? 'HH:00' : 'DD'))));
      })))), /*#__PURE__*/_react["default"].createElement("section", {
        className: "information-trucks"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "information-trucks__list"
      }, trafficItems && trafficItems.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "truck-item",
          key: item
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "truck-item__number ".concat(selectedViewMode === 'TRUCK' ? 'truck-item__number--truck' : 'truck-item__number--trip', " ")
        }, /*#__PURE__*/_react["default"].createElement("span", null, selectedViewMode === 'TRUCK' ? "Cami\xF3n: ".concat(item.TruckNumber) : "Viaje: ".concat(item.tripNumber))), /*#__PURE__*/_react["default"].createElement("div", {
          className: "truck-item__info"
        }, /*#__PURE__*/_react["default"].createElement("figure", {
          className: "truck-item__info-companyLogo"
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: item.companyLogo,
          alt: "companyLogo"
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "truck-item__info-model"
        }, /*#__PURE__*/_react["default"].createElement("figure", {
          className: "truck-item__info-model__icon"
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: item.icon,
          alt: "icon"
        })), /*#__PURE__*/_react["default"].createElement("span", {
          className: "truck-item__info-model__title ".concat(selectedViewMode === 'TRUCK' ? 'truck-item__info-model__title--truck' : 'truck-item__info-model__title--trip')
        }, selectedViewMode === 'TRUCK' ? "".concat(item.tripNumber) : "".concat(item.TruckNumber)))));
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "information-trucks__status"
      }, !!trafficItems === false && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("figure", null, /*#__PURE__*/_react["default"].createElement("img", {
        src: "",
        alt: ""
      })), /*#__PURE__*/_react["default"].createElement("span", {
        className: "information-trucks__status__info"
      }, selectedViewMode === 'TRUCK' ? 'Viaje(s) no encontrados' : 'No hay viajes disponibles por el momento')))));
    }
  }]);

  return TrafficGridContainer;
}(_react.Component);

TrafficGridContainer.propTypes = {
  viewMode: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].oneOf(['TRIP', 'TRUCK'])]),
  maxViewItems: _propTypes["default"].number,
  className: _propTypes["default"].string,
  trafficItems: _propTypes["default"].arrayOf(_propTypes["default"].exact({
    TruckNumber: _propTypes["default"].string.isRequired,
    companyLogo: _propTypes["default"].string.isRequired,
    icon: _propTypes["default"].string.isRequired,
    tripNumber: _propTypes["default"].string.isRequired
  }))
};
TrafficGridContainer.defaultProps = {
  viewMode: 'TRIP',
  maxViewItems: 6,
  className: '',
  trafficItems: undefined
};
var _default = TrafficGridContainer;
exports["default"] = _default;